class MultiDivisionSponsor {
  constructor(root) {
    this.root = root;
    this.button = root.querySelector('.multi-division-sponsor__submit');
    this.errorEl = root.querySelector('.multi-division-sponsor__error');
    this.defaultButtonText = this.button ? this.button.textContent.trim() : 'Add selected divisions to cart';

    if (this.button) {
      this.button.addEventListener('click', () => this.handleClick());
    }
  }

  getSelectedVariantIds() {
    return Array.from(this.root.querySelectorAll('.multi-division-sponsor__checkbox:checked')).map(
      (el) => el.value
    );
  }

  getFileInput() {
    return document.querySelector('input[type="file"].custom-property__input');
  }

  getPropertyFields() {
    return Array.from(document.querySelectorAll('[name^="properties["]')).filter(
      (el) => el.type !== 'file'
    );
  }

  showError(message) {
    if (!this.errorEl) return;
    if (!message) {
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
      return;
    }
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  }

  setBusy(isBusy) {
    if (!this.button) return;
    this.button.disabled = isBusy;
    this.button.textContent = isBusy ? 'Adding…' : this.defaultButtonText;
  }

  async handleClick() {
    this.showError('');

    const variantIds = this.getSelectedVariantIds();
    if (variantIds.length === 0) {
      this.showError('Please select at least one division to sponsor.');
      return;
    }

    const fileInput = this.getFileInput();
    if (fileInput && fileInput.required && (!fileInput.files || fileInput.files.length === 0)) {
      this.showError('Please upload your logo before adding to cart.');
      return;
    }

    const propertyFields = this.getPropertyFields();
    for (const field of propertyFields) {
      if (field.required && !field.value.trim()) {
        this.showError('Please fill in all required fields before adding to cart.');
        field.focus();
        return;
      }
    }

    this.setBusy(true);

    try {
      for (const variantId of variantIds) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (fileInput && fileInput.files && fileInput.files[0]) {
          formData.append(fileInput.name, fileInput.files[0]);
        }

        for (const field of propertyFields) {
          if (field.value) {
            formData.append(field.name, field.value);
          }
        }

        const response = await fetch('/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        if (!response.ok) {
          let message = 'Something went wrong adding a division to your cart.';
          try {
            const data = await response.json();
            if (data && data.message) message = data.description || data.message;
          } catch (e) {
            /* ignore parse errors, use default message */
          }
          throw new Error(message);
        }
      }

      window.location.href = '/cart';
    } catch (err) {
      this.showError((err && err.message) || 'Something went wrong. Please try again.');
      this.setBusy(false);
    }
  }
}

document.querySelectorAll('.multi-division-sponsor').forEach((el) => new MultiDivisionSponsor(el));
